var _style, _g, _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _g2, _path8, _g3, _g4, _g5, _g6, _path9, _polygon2, _polygon3, _polygon4, _polygon5, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F4F7FA;}\r\n\t.st1{fill:#97A6B7;}\r\n\t.st2{fill:#D8DEE8;}\r\n\t.st3{opacity:0.74;fill:#FFFFFF;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{opacity:0.3;fill:#97A6B7;}\r\n\t.st6{fill:url(#SVGID_1_);}\r\n\t.st7{opacity:0.5;fill:#FFFFFF;}\r\n\t.st8{fill:#91B3FA;}\r\n\t.st9{fill:url(#SVGID_2_);}\r\n\t.st10{fill:url(#SVGID_3_);}\r\n\t.st11{fill:url(#SVGID_4_);}\r\n\t.st12{fill:url(#SVGID_5_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3150.7,2407.2c-138.4,368.3-425.4,561.5-535.2,626.7c-565.9,336-1415.5,233.3-1849.7-305.8 c-278.1-345.2-281.7-740.3-278.9-852.8c15.4-610.9,465.4-1284,1129-1380.5c734.6-106.8,1239,539.5,1288,604.5 C2963,1177.9,3391.6,1766.1,3150.7,2407.2z"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2505.1,863.9L667,761.8c-42.3-2-80.4,42.4-80.4,79.6v2273c0,51.7,55,62.1,97.3,57.9l1821.3-178.6 c33.3-3.3,60.1-32.5,60.1-65.3V926.2C2565.2,893.4,2538.4,865.5,2505.1,863.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2535.3,845.9l-1841.7-87c-42.3-2-76.8,26.8-76.8,64.3V3114c0,37.5,34.5,64.6,76.8,60.4l1841.7-182 c33.3-3.3,60.1-32.8,60.1-65.8V908.6C2595.4,875.5,2568.6,847.5,2535.3,845.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M693.6,3143.3c-22.8,2.2-41.5-12.4-41.5-32.7V824.7c0-20.2,18.6-35.8,41.5-34.8l1841.7,83.5 c18,0.8,32.6,16,32.6,33.9v2021.7c0,17.9-14.6,33.9-32.6,35.6L693.6,3143.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2416.6,2910.5 841.4,3056.3 841.4,947.3 2416.6,1004.3  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1786.6,1014.6l-629.6,7.6l14.1-136.3c1.1-17.7,14.4-32.3,32-34.9l106.6-15.7c12.6-1.9,23.4-9.8,28.8-21.3 l11.6-24.1l278.9,16.5L1786.6,1014.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1157.0034,
    y1: 803.5927,
    x2: 2146.7136,
    y2: 803.5927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M2122.7,926.2c-3-15.4-15.9-26.3-32.1-27l-100.6-4.3c-45.7-2-79.1-37.6-77.5-82.7l3.9-104.6 c0.7-19.3-13.7-34.8-33.4-36l-33.1-1.9c-25.2-1.4-42-22.8-38.4-47.5c6.2-43.1-24.6-80.3-69.2-83.2c-44.9-2.9-86.9,30-93.6,73.7 c-1,6.5-3.3,12.9-7,18.6c-10.4,16-28.6,24.8-46.4,23.8l-34.1-2c-20.7-1.2-40.3,12.7-45.5,32.3l-28.3,106.1 c-12.3,45.9-58.5,79.1-107.6,77l-110.4-4.8c-18.1-0.8-35.8,9.3-44.1,25.2l-66.5,126.7c-5.4,10.4,1.3,21.6,13.1,22l957,30.5 c10.5,0.3,19.4-9.7,17.4-19.7L2122.7,926.2z M1728.9,629.6c-13.2-0.8-22.3-11.8-20.4-24.6c1.9-12.8,14.2-22.5,27.3-21.7 c13.2,0.8,22.2,11.8,20.3,24.6C1754.2,620.7,1742,630.4,1728.9,629.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2128.4,929c-3-15.4-15.9-26.3-32.1-27l-100.6-4.3c-45.7-2-79.1-37.6-77.5-82.7l3.9-104.6 c0.7-19.3-13.7-34.8-33.4-36l-33.1-1.9c-25.2-1.4-42-22.8-38.4-47.5c6.2-43.1-24.6-80.3-69.2-83.2c-44.9-2.9-86.9,30-93.6,73.7 c-1,6.5-3.3,12.9-7,18.6c-10.4,16-28.6,24.8-46.4,23.8l-34.1-2c-20.7-1.2-40.3,12.7-45.5,32.3l-28.3,106.1 c-12.3,45.9-58.5,79.1-107.6,77l-110.4-4.7c-18.1-0.8-35.8,9.3-44.1,25.2l-66.5,126.7c-5.4,10.4,1.3,21.6,13.1,22l957,30.5 c10.5,0.3,19.4-9.7,17.4-19.7L2128.4,929z M1734.5,632.4c-13.2-0.8-22.3-11.8-20.4-24.6c1.9-12.8,14.2-22.5,27.3-21.7 c13.2,0.8,22.2,11.8,20.3,24.6C1759.9,623.5,1747.7,633.2,1734.5,632.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1964.6,987.2c-85.4-50.6-150.9-14.7-204.1-71.8c-57-61.1-18.5-141.5-77.5-179.5 c-37.7-24.3-71.4-2.9-115.3-9.4c-16.1-2.4-33.2-8.5-51-20.5l-23.6,88.5c-12.3,45.9-58.5,79.1-107.6,77l-110.4-4.7 c-18.1-0.8-35.8,9.3-44.1,25.2l-66.5,126.7c-5.4,10.4,1.3,21.6,13.1,22l869.7,27.7C2025.5,1034.9,1998.3,1007.2,1964.6,987.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1164.6,1244.8c86.7-7.1,249.2-11,338.6-12.7c37.9-0.7,71.3,24.8,80.3,61.6 c17.6,71.5,42.1,195.6,39.8,327.3c-0.7,39.4-32.8,71.1-72.3,70.8l-330.1-1.8c-40.6-0.2-74.4-31.1-78.4-71.5l-30.6-310.3 C1108.7,1276,1132.4,1247.5,1164.6,1244.8z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1190.2,1960.1v120.5l-133.4,4.3v-121.7L1190.2,1960.1L1190.2,1960.1z M1204.2,1945.8l-161.3,3.8v149.7 l161.3-5.2V1945.8L1204.2,1945.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2274.8,2059.4 1263.6,2092.2 1263.6,1944.4 2274.8,1920.6  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1190.2,2176.3v120.5l-133.4,6v-121.7L1190.2,2176.3L1190.2,2176.3z M1204.2,2161.8l-161.3,5.9v149.7 l161.3-7.3V2161.8L1204.2,2161.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2274.8,2261.6 1263.6,2307.4 1263.6,2159.7 2274.8,2122.8  "
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1190.2,2392.4v120.5l-133.4,7.7V2399L1190.2,2392.4L1190.2,2392.4z M1204.2,2377.8l-161.3,7.9v149.7 l161.3-9.4V2377.8L1204.2,2377.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2274.8,2463.9 1263.6,2522.6 1263.6,2374.9 2274.8,2325.1  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1190.2,2608.6v120.5l-133.4,9.5v-121.6L1190.2,2608.6L1190.2,2608.6z M1204.2,2593.8l-161.3,10v149.7 l161.3-11.4V2593.8L1204.2,2593.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2274.8,2666.1 1263.6,2737.8 1263.6,2590.1 2274.8,2527.3  "
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1042.9,1817.9c-1.8,0-3.6-0.7-4.9-2c-1.3-1.3-2.1-3.1-2.1-5v-698.5c0-1.9,0.8-3.7,2.1-5c1.3-1.3,3.1-2,5-2 l641.3,16.4c3.8,0.1,6.8,3.2,6.8,7V1801c0,3.8-3.1,6.9-6.9,7l-641.3,9.9C1043,1817.9,1042.9,1817.9,1042.9,1817.9z  M1049.9,1119.6v684.3l627.3-9.7v-658.5L1049.9,1119.6z M1684.2,1801L1684.2,1801L1684.2,1801z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2274.8,1229.3 1784.9,1219.4 1784.9,1131.4 2274.8,1144  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2274.8,1418.9 1784.9,1414.9 1784.9,1370.9 2274.8,1376.3  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2274.8,1489.3 1784.9,1487.4 1784.9,1443.4 2274.8,1446.6  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2274.8,1559.6 1784.9,1559.9 1784.9,1515.9 2274.8,1516.9  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1122.6,2073.9c-4.2,0.1-8.1-1.8-10.3-5l-40.6-59.6c-3.5-5.2-1.7-12.1,4-15.4c5.7-3.4,13.1-1.9,16.6,3.2 l30,44.1l58-93.2c3.3-5.4,10.7-7.3,16.3-4.3c5.7,3,7.6,9.7,4.3,15l-68,109.4c-2.1,3.4-6,5.6-10.2,5.8 C1122.7,2073.9,1122.7,2073.9,1122.6,2073.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1122.6,2513.8c-4.2,0.2-8.1-1.5-10.3-4.7l-40.6-58.6c-3.5-5.1-1.7-12,4-15.5c5.7-3.5,13.1-2.3,16.6,2.8 l30,43.4l58-94.7c3.3-5.4,10.7-7.6,16.3-4.8c5.7,2.8,7.6,9.5,4.3,14.9l-68,111.1c-2.1,3.5-6,5.8-10.2,6.1 C1122.7,2513.8,1122.7,2513.8,1122.6,2513.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1122.6,2294.8c-4.2,0.2-8.1-1.6-10.3-4.8l-40.6-59.1c-3.5-5.1-1.7-12,4-15.5c5.7-3.4,13.1-2.1,16.6,3 l30,43.8l58-93.9c3.3-5.4,10.7-7.4,16.3-4.6c5.7,2.9,7.6,9.6,4.3,15l-68,110.3c-2.1,3.5-6,5.7-10.2,5.9 C1122.7,2294.8,1122.7,2294.8,1122.6,2294.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1122.6,2713.8c-4.2,0.3-8.1-1.4-10.3-4.6l-40.6-58.1c-3.5-5-1.7-12,4-15.6c5.7-3.6,13.1-2.4,16.6,2.6 l30,43l58-95.4c3.3-5.5,10.7-7.7,16.3-5c5.7,2.7,7.6,9.4,4.3,14.9l-68,111.9c-2.1,3.5-6,5.9-10.2,6.2 C1122.7,2713.8,1122.7,2713.8,1122.6,2713.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -2642.6372,
    y1: 1874.4293,
    x2: -2531.6082,
    y2: 1554.0316,
    gradientTransform: "matrix(-1 0 0 1 -1161.2548 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1442,1565.4v120.8c0,9.8-7.1,18.1-16.8,19.5c-16,2.4-40.7,4.3-62-2.1c-9.8-2.9-15.8-12.7-13.9-22.8 l22.5-115.4H1442z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -2683.7888,
    y1: 1609.0133,
    x2: -2459.7166,
    y2: 1319.3882,
    gradientTransform: "matrix(-1 0 0 1 -1161.2548 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1486.6,1388.5c0,0,76.5,204-20.7,228.7c-114.4,29.1-153-122-153-122S1413.3,1206.8,1486.6,1388.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1185.6718,
    y1: 1350.0568,
    x2: 1303.2737,
    y2: 1350.0568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1282.3,1399.9c0,0,41.3-79.6,8.1-112.4c-33.3-32.8-95.2-18.3-104,47 C1177.5,1399.9,1262.1,1471,1282.3,1399.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1229.3417,
    y1: 1426.9547,
    x2: 1518.4603,
    y2: 1426.9547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1517.6,1371.6c4.6,16.8-10.4,32.3-27.4,28.4c-17.1-3.9-38-7.5-56.2-6.8c-122.7,4.8-74.9,84.5-74.9,97.2 c0,26.1-25.6-13.6-27.1-4.8c-3.2,19.1,11.7,77.1,11.7,77.1s-78.7-16.6-104.1-54.8c-25.5-38.2,3.2-124.3,12.7-156.2 c9.6-31.9,73.3-63.7,108.4-60.6C1392.1,1294.1,1492.2,1279.2,1517.6,1371.6z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.6438eabbf02bd5f78dbf5875be88f27a.svg";
export { ForwardRef as ReactComponent };